<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
    <transition name="float-back-fade">
      <button
        v-if="showFloatingBack"
        class="floating-back-btn"
        :style="{ bottom: floatingBackBottom }"
        @click="scrollToTop"
      >
        <van-icon name="back-top" />
      </button>
    </transition>
  </div>
</template>

<script>
import watermark from './utils/createWatermark';
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      showFloatingBack: false,
      scrollThreshold: 240,
      tabBarRouteNames: [
        'encounter',
        'matchmakerList',
        'activity',
        'conversationList',
        'memberCenter',
        'matchmakerCenter'
      ]
    };
  },
  methods: {
    watermarkContent() {
      if(this.role === 'Member' && this.baseInfo) {
        return this.baseInfo.serialNumber + this.baseInfo.name;
      }
      if(this.role === 'Matchmaker' && this.baseInfo) {
        return this.baseInfo.employeeNo + this.baseInfo.name;
      }
    },
    getScrollTop() {
      return window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
    },
    handleScroll() {
        if (this.$route.name === 'chatRoom') {
          this.showFloatingBack = false;
          return;
        }
      this.showFloatingBack = this.getScrollTop() >= this.scrollThreshold;
    },
    scrollToTop() {
      if (typeof window.scrollTo === 'function') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        return;
      }
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  updated() {
    if(this.watermarkContent()) {
        watermark.set(this.watermarkContent());
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'chatRoom') {
        this.showFloatingBack = false;
        return;
      }
      this.showFloatingBack = false;
      this.$nextTick(() => {
        this.handleScroll();
      });
    }
  },
  computed: {
    ...mapGetters([
      'baseInfo',
      'role'
    ]),
    floatingBackBottom() {
      if (this.tabBarRouteNames.includes(this.$route.name)) {
        return '5.5rem';
      }
      return '2.5rem';
    }
  },
}
</script>

<style lang="less">
  @import url('./style/theme-variables.less');

  *{
    padding: 0;
    margin: 0;
  }

  html,
  body,
  #app {
    min-height: 100%;
    background: @bg-gray;
    color: @text-primary;
    font-family: @font-family-cn;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .floating-back-btn {
    position: fixed;
    right: 0.8rem;
    z-index: 150;
    height: 2.1rem;
    width: 2.1rem;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: @gradient-primary;
    color: @text-light;
    box-shadow: @shadow-btn;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .van-icon {
      font-size: 0.82rem;
      color: @text-light;
    }
  }

  .float-back-fade-enter-active,
  .float-back-fade-leave-active {
    transition: opacity .2s ease, transform .2s ease;
  }

  .float-back-fade-enter,
  .float-back-fade-leave-to {
    opacity: 0;
    transform: translateY(0.3rem);
  }

  input {
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: none;
  }

    .createSuccessInfo {
      width: auto !important;
      max-width: 80% !important;
      min-width: 6rem !important;
      padding: 0.6rem 0.8rem !important;

      .van-toast__text {
        word-break: break-all;
        white-space: normal;
        line-height: 1.5;
      }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue